import { render, staticRenderFns } from "./PanicNotification.vue?vue&type=template&id=80556742&"
import script from "./PanicNotification.vue?vue&type=script&lang=js&"
export * from "./PanicNotification.vue?vue&type=script&lang=js&"
import style0 from "./PanicNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports